import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Badge, Typography, TextField, Grid } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { customDateFormat } from "../CashAllocation/utils";
import { numberFormatter } from "../../utils/generalFunctions"
import { format } from "date-fns";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { ViewAndEditBankTransaction } from "../bankTransactions/ViewAndEditTxnDialog";
import CommonMultiFileUpload from "../documents/CommonMultiFileUpload";

export const ViewGenericWorkflowDialog = ({
    workflowTxnData,
    workflowSelectedName,
    currentWorkflowDetails
}) => {
    const { Bank_Transaction_Id, Receivable_Amount } = workflowTxnData;

    const [fieldsData, setFieldsData] = useState({
        Bank_Transaction_Id: Bank_Transaction_Id,
        Receivable_Amount: Receivable_Amount,
        New_Receivable_Amount: 0,
        comments: ""
    });

    const [isOpenTxnDialog, setIsOpenTxnDialog] = useState(false)

    const isEmailWorkflow = workflowSelectedName?.startsWith("EMAIL_");
    const isWorkFlowChangeBankTxn = workflowSelectedName == "CHANGE_BANK_TRANSACTION_AMOUNT"
    const [isFileUploadDialogOpen, setIsFileUploadDialogOpen] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);

    const writeoffWorkflowTxnArrayData = useMemo(
        () => [
            {
                label: "Policy#",
                value: workflowTxnData?.cash_allocation?.policy_id,
            },
            {
                label: "Allocation Status",
                value: workflowTxnData?.cash_allocation?.allocation_status,
            },
            {
                label: "Bank Txn Id",
                value: workflowTxnData?.bank_txn?.Bank_Transaction_Id,
            },
            {
                label: "Write off Amount",
                value: numberFormatter(workflowTxnData?.writeoff_amt),
            },

            {
                label: "write off Reason",
                value: workflowTxnData?.writeoff_reason,
            },
            {
                label: "Comments",
                value: workflowTxnData?.comments,
            }
        ],
        [workflowTxnData]
    );

    const refundWorkflowTxnArrayData = useMemo(() => [
        {
            label: "Policy#",
            value: workflowTxnData?.cash_allocation?.policy_id,
        },
        {
            label: "Allocation Status",
            value: workflowTxnData?.cash_allocation?.allocation_status,
        },
        {
            label: "Bank Txn Id",
            value: workflowTxnData?.bank_txn?.Bank_Transaction_Id,
        },
        {
            label: "Refund Amount",
            value: numberFormatter(workflowTxnData?.refund_amt),
        },
        {
            label: "Refund Reason",
            value: workflowTxnData?.refund_reason,
        },
        {
            label: "Comments",
            value: workflowTxnData?.comments,
        }
    ],
        [workflowTxnData]
    )

    const correctionTypeWorkflowTxnArrayData = useMemo(() => [
        {
            label: "Policy#",
            value: workflowTxnData?.cash_allocation?.policy_id,
        },
        {
            label: "Allocation Status",
            value: workflowTxnData?.cash_allocation?.allocation_status,
        },
        {
            label: "Correction Description",
            value: workflowTxnData?.correction_type?.correction_description,
        },
        {
            label: "Correction Reason",
            value: workflowTxnData?.correction_type?.correction_type,
        },
    ],
        [workflowTxnData]
    )

    const correctiveTransferWorkflowTxnArrayData = useMemo(() => [
        {
            label: "Policy#",
            value: workflowTxnData?.cash_allocation?.policy_id,
        },
        {
            label: "Allocation Status",
            value: workflowTxnData?.cash_allocation?.allocation_status,
        },
        {
            label: "Bank Txn Id",
            value: workflowTxnData?.bank_txn?.Bank_Transaction_Id,
        },
        {
            label: "Bank Currency",
            value: workflowTxnData?.cash_allocation?.bank_txn?.Currency,
        },
        {
            label: "PT Bank Account Number",
            value: workflowTxnData?.PT_bank_acct_Number,
        },
        {
            label: "Treasury Confirmed Transfer Date",
            value: customDateFormat(workflowTxnData?.treasury_confirmed_transfer_date),
        },
        {
            label: "Transfer to PT Entity Name",
            value: workflowTxnData?.transfer_pt_bank_account_name,
        },
        {
            label: "Transfer Amount",
            value: numberFormatter(workflowTxnData?.transfer_amt),
        },
    ],
        [workflowTxnData]
    )

    const crossAllocationWorkflowTxnArrayData = useMemo(() => [
        {
            label: "Policy#",
            value: workflowTxnData?.cash_allocation?.policy_id,
        },
        {
            label: "Allocation Status",
            value: workflowTxnData?.cash_allocation?.allocation_status,
        },
        {
            label: "Bank Txn Id",
            value: workflowTxnData?.bank_txn?.Bank_Transaction_Id,
        },
        {
            label: "Cross Allocation Amount",
            value: numberFormatter(workflowTxnData?.ca_amt),
        },
        {
            label: "New Allocation Date",
            value: customDateFormat(workflowTxnData?.new_allocation_date),
        },
        {
            label: "Process Date",
            value: customDateFormat(workflowTxnData?.process_date),
        },
        {
            label: "Cross Allocation Change",
            value: workflowTxnData?.ca_change,
        },
        {
            label: "Cross Allocation Impact",
            value: workflowTxnData?.ca_impact,
        },
    ],
        [workflowTxnData]
    )

    const cfiWorkflowTxnArrayData = useMemo(() => [
        {
            label: "Policy#",
            value: workflowTxnData?.cash_allocation?.policy_id,
        },
        {
            label: "Allocation Status",
            value: workflowTxnData?.cash_allocation?.allocation_status,
        },
        {
            label: "Bank Txn Id",
            value: workflowTxnData?.bank_txn?.Bank_Transaction_Id,
        },
        {
            label: "CFI Amount",
            value: numberFormatter(workflowTxnData?.cfi_amt),
        },
        {
            label: "CFI Impact",
            value: workflowTxnData?.cfi_impact,
        },
        {
            label: "Request Date",
            value: customDateFormat(workflowTxnData?.request_date),
        },
        {
            label: "Process Date",
            value: customDateFormat(workflowTxnData?.process_date),
        },
        {
            label: "Approved Date",
            value: customDateFormat(workflowTxnData?.approved_date),
        },
        {
            label: "Approver Name",
            value: workflowTxnData?.aprover_name,
        },
        {
            label: "CFI Change",
            value: workflowTxnData?.cfi_change,
        },
    ],
        [workflowTxnData]
    )

    const paymentNoVarianceWorkflowTxnArrayData = useMemo(() => [
        {
            label: "Policy#",
            value: workflowTxnData?.cash_allocation?.policy_id,
        },
        {
            label: "Allocation Status",
            value: workflowTxnData?.cash_allocation?.allocation_status,
        },
        {
            label: "Bank Txn Id",
            value: workflowTxnData?.bank_txn?.Bank_Transaction_Id,
        },
        {
            label: "Request Date",
            value: customDateFormat(workflowTxnData?.request_date),
        },
        {
            label: "Process Date",
            value: customDateFormat(workflowTxnData?.process_date),
        },
        {
            label: "Approved Date",
            value: customDateFormat(workflowTxnData?.approved_date),
        },
        {
            label: "Approver Name",
            value: workflowTxnData?.aprover_name,
        },
    ],
        [workflowTxnData]
    )

    const workflowDialogTitle = () => {
        let title = "";
        switch (workflowSelectedName) {
            case "WF_WRITEOFF":
                title = "Write off";
                break;
            case "WF_REFUND":
                title = "Refund";
                break;
            case "WF_CORRECTION_TYPES":
                title = "Correction Reasons";
                break;
            case "WF_CORRECTIVE_TRANSFER":
                title = "Corrective Transfer";
                break;
            case "WF_CROSS_ALLOCATION":
                title = "Cross Allocation";
                break;
            case "WF_CFI":
                title = "CFI"
                break;
            default:
                break;
        }
        return title;
    }

    const getDisplayData = () => {
        let dataDetails = [];
        if (isEmailWorkflow) return [];

        if (isWorkFlowChangeBankTxn) return []

        switch (workflowSelectedName) {
            case "WF_WRITEOFF":
                dataDetails = writeoffWorkflowTxnArrayData;
                break;
            case "WF_REFUND":
                dataDetails = refundWorkflowTxnArrayData;
                break;
            case "WF_CORRECTION_TYPES":
                dataDetails = correctionTypeWorkflowTxnArrayData;
                break;
            case "WF_CORRECTIVE_TRANSFER":
                dataDetails = correctiveTransferWorkflowTxnArrayData;
                break;
            case "WF_CROSS_ALLOCATION":
                dataDetails = crossAllocationWorkflowTxnArrayData;
                break;
            case "WF_CFI":
                dataDetails = cfiWorkflowTxnArrayData;
                break;
            case "WF_PAYMENT_NOVARIANCE":
                dataDetails = paymentNoVarianceWorkflowTxnArrayData;
                break;
            default:
                break;
        }

        return dataDetails;
    }

    const handleFileUploadDialog = () => {
        // fileInputRef.current.click();
        setIsFileUploadDialogOpen(true);
    };

    useEffect(() => {
        if (workflowTxnData?.attachments) {
            const files = workflowTxnData?.attachments?.split(",");
            setUploadedFiles(files);
        }
    }, [workflowTxnData]);

    const EmailView = ({ data }) => {

        // Format date nicely
        const formattedDate = data?.date
            ? format(new Date(data.date), "MMM dd, yyyy, hh:mm a")
            : "";

        // Attachment (string or null)
        const attachmentUrl = data.attachments || null;
        // setUploadedFiles(attachmentUrl?.split(","));
        const attachmentName = attachmentUrl ? attachmentUrl.split("/").pop().split("?")[0] : "";
        return (
            <Box sx={{ marginBottom: "10px", padding: 2, borderRadius: "8px", backgroundColor: "#fafafa", border: "1px solid #e0e0e0" }}>
                {/* Header: Subject left, Date + Attachment right */}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 2 }}>
                    {/* Subject */}
                    <Typography variant="h6">{data?.subject || ""}</Typography>

                    {/* Right side: Date + Attachment */}
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                        {formattedDate && (
                            <Typography variant="body2" color="text.secondary">
                                {formattedDate}
                            </Typography>
                        )}

                        {attachmentUrl && (
                            <div style={{
                                position: "relative",
                                top: "7px",
                            }}>
                                <div className="FileUploadIcon">
                                    <div
                                        style={{ display: "flex", flexDirection: "column" }}
                                        onClick={handleFileUploadDialog}
                                    >
                                        <span
                                            style={{ display: "flex", justifyContent: "center", fontSize: "14px" }}
                                        >
                                            Files:
                                            <Badge
                                                badgeContent={uploadedFiles?.length}
                                                color="primary"
                                                size="small"
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'right',
                                                }}
                                            // style={{ marginLeft: "5px" }}
                                            >
                                                <AttachFileIcon style={{ fontSize: 15, paddingTop: "3px", cursor: "pointer" }} />
                                            </Badge>
                                        </span>
                                    </div>
                                    <CommonMultiFileUpload
                                        isFileUploadDialogOpen={isFileUploadDialogOpen} //to open

                                        uploadedFiles={uploadedFiles}
                                        setUploadedFiles={setUploadedFiles}

                                        setIsFileUploadDialogOpen={setIsFileUploadDialogOpen}
                                        currentWorkflowDetails={workflowTxnData}// for now
                                    />
                                </div>
                            </div>
                        )}
                    </Box>
                </Box>

                {/* From / To / CC */}
                <Box sx={{ fontSize: 14, marginBottom: 1 }}>
                    <b>From:</b> {data?.from_email}
                </Box>
                <Box sx={{ fontSize: 14, marginBottom: 1 }}>
                    <b>To:</b> {data?.to_email}
                </Box>
                {data?.cc && (
                    <Box sx={{ fontSize: 14, marginBottom: 1 }}>
                        <b>CC:</b> {data?.cc}
                    </Box>
                )}

                <Divider sx={{ marginY: 2 }} />

                {/* Body */}
                <Box sx={{ whiteSpace: "pre-wrap", fontSize: 14 }}>
                    {data?.body || ""}
                </Box>
            </Box>
        );
    };


    const renderWorkFlowBankChangeTxn = () => {
        const displayNewRequestedAmount = () => {
            if (Object.keys(currentWorkflowDetails)?.length) {
                const { changefields } = currentWorkflowDetails;
                return changefields?.Receivable_Amount ?? changefields?.allocated_amount;
            } else {
                return fieldsData?.New_Receivable_Amount ?? 0;
            }
        };
        return (
            <Box>
                <Typography sx={{
                    color: "#1976d2",
                    cursor: "pointer",
                    fontSize: "15px",
                    paddingLeft: "12px",
                    paddingBottom: "20px"
                }}
                    onClick={() => setIsOpenTxnDialog(true)}>View Bank Transaction</Typography>
                <Box
                    style={{
                        paddingLeft: "12px",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: "15px",
                    }}
                >
                    <Typography>Receivable Amount</Typography>
                    <TextField
                        placeholder="Transaction amount"
                        size="small"
                        value={workflowTxnData?.Receivable_Amount}
                        disabled={true}
                    />
                </Box>
                <Box
                    style={{
                        paddingLeft: "12px",
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: "55px",
                    }}
                >
                    <Typography>New Amount</Typography>
                    <TextField
                        value={displayNewRequestedAmount()}
                        placeholder="Enter new amount"
                        size="small"
                        disabled={true}
                    />
                </Box>

                {isOpenTxnDialog &&
                    <ViewAndEditBankTransaction
                        isOpenTxnDialog={isOpenTxnDialog}
                        setIsOpenTxnDialog={setIsOpenTxnDialog}
                        txnMode={"VIEW"}
                        txnData={workflowTxnData}
                    />}
            </Box>
        )
    }
    return (
        <Box>
            {/* <Typography
                sx={{
                    backgroundColor: "rgb(250, 250, 250) !important",
                    marginBottom: "10px !important",
                    padding: "20px !important",
                    borderRadius: "7px !important",
                    border: "1px solid rgb(224,224,224) !important",
                }}
            >
                {workflowDialogTitle()}
            </Typography> */}
            <Box>
                {isWorkFlowChangeBankTxn ? (
                    renderWorkFlowBankChangeTxn()
                ) : isEmailWorkflow ? (
                    <EmailView data={workflowTxnData} />
                ) : (
                    <Box
                        sx={{
                            backgroundColor: "rgb(250, 250, 250)",
                            marginBottom: "10px",
                            padding: "20px",
                            borderRadius: "7px",
                            border: "1px solid rgb(224,224,224)",
                        }}
                    >
                        <Grid container sx={{ marginTop: "20px" }}>
                            {getDisplayData().map(({ label, value }, i) => (
                                <Grid
                                    item
                                    xs={12}
                                    md={6}
                                    key={label}
                                    paddingLeft={i % 2 ? 2 : 0}
                                    paddingRight={i % 2 ? 0 : 2}
                                    marginBottom={2}
                                >
                                    <span>{label}</span>
                                    <span style={{ fontWeight: "bold" }}>
                                        : {value}
                                    </span>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                )}
            </Box>
        </Box>
    );
}